<template>
  <div class="flex-center">
    <el-button type="primary" class="vc-topup-btn" @click="initBraintree()">
      <img src="@/assets/images/vc_dark.svg" alt="" />
      VidCents<br />
      Top up
    </el-button>
    <el-dialog
      class="topup-dialog"
      :visible="dialog"
      width="1090px"
      @close="setDialog(false)"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-card class="data">
            <div class="data-title" slot="header">
              <img class="report-img" src="@/assets/images/tracks.svg" alt="" />
              <span>DEPOSIT</span>
              <i class="el-icon-close pointer" @click="setDialog(false)"></i>
            </div>
            <div class="flex-space-between">
              <!-- Credit card -->
              <div
                class="payment"
                :class="{ active: activeModal === 'Credit Card' }"
              >
                <h4>CREDIT CARD</h4>
                <el-alert type="success" v-if="nonce">
                  Successfully generated nonce.
                </el-alert>
                <el-alert type="danger" v-if="error">
                  {{ error }}
                </el-alert>
                <el-form class="form">
                  <el-form-item
                    @focus="activeModal = 'Credit Card'"
                    label="Amount $"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      v-model="amount"
                      placeholder="100$"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    @focus="activeModal = 'Credit Card'"
                    label="Credit Card Number"
                    :label-width="formLabelWidth"
                  >
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item
                    @focus="activeModal = 'Credit Card'"
                    label="Expire Date"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    @focus="activeModal = 'Credit Card'"
                    label="CVV"
                    :label-width="formLabelWidth"
                  >
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <el-button
                  type="primary btn-main ml-auto"
                  @click="confirmBar = true"
                  >Submit</el-button
                >
              </div>
              <!-- Paypal -->
              <div
                class="payment"
                :class="{ active: activeModal === 'Paypal' }"
              >
                <h4>Paypal</h4>
                <el-alert type="success" v-if="nonce">
                  Successfully generated nonce.
                </el-alert>
                <el-alert type="danger" v-if="error">
                  {{ error }}
                </el-alert>
                <el-form class="form">
                  <el-form-item label="Amount $" :label-width="formLabelWidth">
                    <el-input
                      @focus="activeModal = 'Paypal'"
                      v-model="amount"
                      placeholder="100$"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    @focus="activeModal = 'Paypal'"
                    label="Username / Email"
                    :label-width="formLabelWidth"
                  >
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
                <el-button
                  type="primary btn-main ml-auto"
                  @click="confirmBar = true"
                  >Submit</el-button
                >
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- <el-alert type="success" v-if="nonce">
        Successfully generated nonce.
      </el-alert>
      <el-alert type="danger" v-if="error">
        {{ error }}
      </el-alert>
      <p>Amount (USD)</p>
      <el-input
        v-model="amount"
        type="number"
        id="amount"
        class="p0"
        placeholder="Amount"
      ></el-input>

      <p>Credit Card Number</p>
      <div id="creditCardNumber"></div>

      <p>Expire Date</p>
      <div id="expireDate"></div>

      <p>CVV</p>
      <div id="cvv"></div>

      <div class="mt20 flex-space-between" id="buttons">
        <el-button id="creditCardButton" type="primary" @click="payWithCreditCard">
          Pay with Credit Card
        </el-button>

        <div id="paypalButton"></div>
      </div> -->
    </el-dialog>

    <el-dialog
      class="confirm-bar"
      title="Deposit"
      :visible.sync="confirmBar"
      width="30%"
    >
      <div>
        <span
          >Your deposit has<br />
          been successfully<br />
          submitted</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import axios from '@/plugins/axios'
import braintree from 'braintree-web'
import paypal from 'paypal-checkout'
import { Message } from 'element-ui'

export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('artistVidCents', ['dialog'])
  },

  data() {
    return {
      hostedFieldInstance: false,
      nonce: '',
      error: '',
      amount: 50,
      payment: {
        amount: 0,
        nonce: null
      },
      formLabelWidth: '200px',
      confirmBar: false,
      activeModal: ''
    }
  },
  methods: {
    ...mapActions('artistVidCents', ['getBalance', 'setpayment']),
    ...mapMutations('artistVidCents', ['setDialog']),
    initBraintree() {
      this.setDialog(true)
      // 134547225
      axios.artist
        .get(`token/${this.user.braintree_customer_id}`)
        .then(r => {
          braintree.client
            .create({
              authorization: r.data
            })
            .then(clientInstance => {
              let options = {
                client: clientInstance,
                styles: {
                  input: {
                    'font-size': '14px',
                    'font-family': 'Helvetica'
                  }
                },
                fields: {
                  number: {
                    selector: '#creditCardNumber',
                    placeholder: 'Enter Credit Card'
                  },
                  cvv: {
                    selector: '#cvv',
                    placeholder: 'Enter CVV'
                  },
                  expirationDate: {
                    selector: '#expireDate',
                    placeholder: '00 / 0000'
                  }
                }
              }
              return Promise.all([
                braintree.hostedFields.create(options),
                braintree.paypalCheckout.create({ client: clientInstance })
              ])
            })
            .then(instances => {
              const hostedFieldInstance = instances[0]
              const paypalCheckoutInstance = instances[1]
              // Use hostedFieldInstance to send data to Braintree
              this.hostedFieldInstance = hostedFieldInstance
              // Setup PayPal Button
              return paypal.Button.render(
                {
                  env: 'sandbox',
                  style: {
                    label: 'pay',
                    size: 'responsive',
                    shape: 'pill',
                    color: 'white',
                    height: 40,
                    tagline: false
                  },
                  payment: () => {
                    if (parseFloat(this.amount) < 50) {
                      Message({
                        type: 'error',
                        message: 'Amount needs to be at least 50$!'
                      })
                      return false
                    } else {
                      return paypalCheckoutInstance.createPayment({
                        flow: 'checkout',
                        intent: 'sale',
                        amount: this.amount,
                        displayName: 'Braintree Testing',
                        currency: 'USD'
                      })
                    }
                  },
                  onAuthorize: data => {
                    return paypalCheckoutInstance
                      .tokenizePayment(data)
                      .then(payload => {
                        this.error = ''
                        this.nonce = payload.nonce
                        this.payment.nonce = this.nonce
                        this.payment.amount = this.amount
                        this.setpayment(this.payment)
                      })
                  },
                  onCancel: () => {
                    console.log('Payment Cancelled')
                  },
                  onError: () => {
                    this.error =
                      'An error occurred while processing the paypal payment.'
                  }
                },
                '#paypalButton'
              )
            })
            .catch(() => {})
        })
        .catch(() => {
          //console.log(e)
        })
    },

    payWithCreditCard() {
      if (parseFloat(this.amount) < 50) {
        Message({
          type: 'error',
          message: 'Amount needs to be at least 50$!'
        })
      } else if (this.hostedFieldInstance) {
        this.error = ''
        this.nonce = ''
        this.hostedFieldInstance
          .tokenize()
          .then(payload => {
            this.nonce = payload.nonce
            this.payment.nonce = this.nonce
            this.payment.amount = this.amount
            this.setpayment(this.payment)
          })
          .catch(err => {
            this.error = err.message
          })
      }
    }
  }
}
</script>

<style scoped>
#creditCardNumber,
#expireDate,
#cvv {
  border: 1px solid #dcdfe6;
  border-radius: 15px;
  color: #606266;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
}
#paypalButton {
  z-index: 10;
}
.el-icon-close {
  margin-left: auto;
  padding: 6px;
  color: white;
  border-radius: 5px;
  background: #d0ced3;
}
</style>
